(function () {
    /**
     * @deprecated
     */
    UX.pageBody = {
        init: function () {
            this.extraControls();
        },
        extraControls() {},
        urlParam: {
            replace: (url, paramName, paramValue) => {
                if (paramValue == null) {
                    paramValue = '';
                }
                let pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
                if (url.search(pattern) >= 0) {
                    return url.replace(pattern, '$1' + paramValue + '$2');
                }
                url = url.replace(/[?#]$/, '');
                return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
            },
            remove: (url, paramName) => {
                let pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
                if (url.search(pattern) >= 0) {
                    url = url.replace(pattern, '');
                    /*eslint-disable*/
                    return url.replace(/\&+$/g, '');
                    /*eslint-enable*/
                } else {
                    return url;
                }
            },
            test: (url, paramName, paramValue) => {
                let pattern;
                if (paramValue !== undefined) {
                    pattern = new RegExp('\\b(' + paramName + '=' + paramValue + ').*?(&|#|$)');
                } else {
                    pattern = new RegExp('\\b(' + paramName + ').*?(&|#|$)');
                }

                return pattern.test(url);
            },
            getParamVal: function (url, paramName) {
                let paramVal = '',
                    paramValMatchedLength = 0;

                url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                    if (key === paramName) {
                        if (paramValMatchedLength > 0) {
                            paramVal += ', ';
                        }
                        paramVal += value;
                        paramValMatchedLength++;
                    }
                });

                return paramVal;
            },
        },
    }; // add to global namespace
})();
